module.exports = __webpack_public_path__ + "img/banner05_info3.5831dde6.svg";